import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import React from 'react';

const ClearIconButton = ({ onClick, sx }) => (
  <IconButton
    size="small"
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onClick();
    }}
    sx={{
      color: 'error.main',
      p: 0,
      ml: 0.5,
      '& .MuiSvgIcon-root': {
        fontSize: '1rem',
      },
      ...sx,
    }}
  >
    <CancelIcon />
  </IconButton>
);

ClearIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  sx: PropTypes.shape({}),
};

ClearIconButton.defaultProps = {
  sx: {},
};

export default ClearIconButton;
